(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.filter('RfGlobalLongTimeFilter', [RfGlobalLongTimeFilterFn]);

    // long-time filter (hour, minute, second), uses moment.locale (set on login)
    function RfGlobalLongTimeFilterFn() {
        return function (date) {
            if (date) {
                return moment(date).format('LTS');
            }
            return date;
        };
    }
})();